import { css } from 'emotion'

export const DateSeparatorSpanStyles = css``
